import { markBox, markPanels } from '@aramis/brand/tokens';

/** The Arch mark from the shared brand geometry (same polygons as every other surface). */
export function AramisMark({ className, duo = true }: { className?: string; duo?: boolean }) {
  return (
    <svg viewBox={`${markBox.x} ${markBox.y} ${markBox.width} ${markBox.height}`} className={className} role="img" aria-label="آرامیس">
      {markPanels.map((p) => (
        <polygon key={p.id} points={p.points.map((xy) => xy.join(',')).join(' ')} fill="currentColor" fillOpacity={duo && p.back ? 0.5 : 1} />
      ))}
    </svg>
  );
}
